import React from 'react';
import { useArchiveYears } from '../hooks/useArchiveYears';
import { useContent } from '../contexts/ContentContext';
import { getConfig } from '../config';
import ExploreSection from './ExploreSection';

export default function YearArchiveSection() {
    const { t } = useContent();
    const archive = useArchiveYears();
    const available = archive.years.filter(year => year.href);
    return <div data-illustration-root="year"><ExploreSection root="year" title={t('illustrations.byYear')} href={archive.latestHref || undefined}>
        {() => archive.error ? <div role="alert"><p>{t('search.error')}</p><button type="button" className="lab-button" onClick={archive.retry}>{t('common.retry')}</button></div>
            : archive.loading ? <p role="status">{t('common.loading')}</p>
            : !available.length ? <p>{t('illustrations.noValues')}</p>
            : available.map(year => <div key={year.year} className="lab-discovery-candidate"><a href={year.href!}>
                {year.cover_thumb && <span className="lab-collection-cover" aria-hidden="true"><img src={new URL(year.cover_thumb, new URL(getConfig().apiBaseUrl).origin).href} alt="" loading="lazy" /></span>}
                <span>{year.year} ({year.count})</span>
            </a></div>)}
    </ExploreSection></div>;
}
